import Vue from 'vue'
import Vuex from 'vuex'
import modules from './store/modules'

Vue.use(Vuex)

export default new Vuex.Store({
  modules,
  state: {
    thumbs: [
      {
        key: 'sound-symbol',
        title: '聲符',
        to: '/sound-symbol',
        modeColor: '#b7e3f5',
        bgColor: '#bce5f6',
        bgImg: require('!file-loader!@/assets/bg_bowl.png'),
      },
      {
        key: 'form-symbol',
        title: '意符/部首',
        to: '/form-symbol',
        modeColor: '#b7e242e0',
        bgColor: '#b3cc3e',
        bgImg: require('!file-loader!@/assets/bg_ball.png'),
      },
      {
        key: 'homophone',
        title: '同音字',
        to: '/homophone',
        modeColor: '#ffd070eb',
        bgColor: '#f3c159',
        bgImg: require('!file-loader!@/assets/bg_sausage.png'),
      },
      {
        key: 'form-similar',
        title: '形似字',
        to: '/form-similar',
        modeColor: '#9ccb3be0',
        bgColor: '#d1eaf0',
        bgImg: require('!file-loader!@/assets/bg_grass.png'),
      },
      {
        key: 'right-word',
        title: '正字與錯字',
        to: '/right-word',
        modeColor: '#98dfe2e0',
        bgColor: '#8acfce',
        bgImg: require('!file-loader!@/assets/bg_house.png'),
      },
      {
        key: 'form-word',
        title: '用字組詞',
        to: '/form-word',
        modeColor: '#bfb5e6e0',
        bgColor: '#9b8cb8',
        bgImg: require('!file-loader!@/assets/bg_carpet.png'),
      },
    ],
  },
  getters: {
    tabs (state, getters) {
      const tabs = [
        {
          label: '主頁',
          icon: require('!svg-inline-loader?classPrefix!@mdi/svg/svg/home.svg'),
          to: '/',
        },
        {
          label: '商店',
          icon: require('!svg-inline-loader?classPrefix!@mdi/svg/svg/basket.svg'),
          to: '/shop',
        },
        {
          label: '帳戶',
          icon: require('!svg-inline-loader?classPrefix!@mdi/svg/svg/account.svg'),
          to: '/account',
        },
        {
          label: '紀錄',
          icon: require('!svg-inline-loader?classPrefix!@mdi/svg/svg/history.svg'),
          to: '/history',
        },
      ]

      if (getters['auth/isAdmin']) {
        tabs.push({
          label: '管理員',
          icon: require('!svg-inline-loader?classPrefix!@mdi/svg/svg/settings.svg'),
          to: '/admin',
        })
      }
      return tabs
    },
  },
})
